var forms = document.querySelectorAll(".newsletter__form");

function menuVisibility() {
  this.classList.toggle("burger--arrow");
  document.querySelector(".header").classList.toggle("menuVisible");
  document.querySelector("body").classList.toggle("hidden");

  if(window.zE)
  {
    zE("messenger",document.querySelector("body").classList.contains("hidden") ? "hide": "show");
  }
}

class NewsletterForm {
  constructor({ inputWrapperSelector, checkboxWrapperSelector }) {
    this.inputWraper = document.querySelector(inputWrapperSelector);
    this.checkboxWrapper = document.querySelector(checkboxWrapperSelector);
    this.label = document.querySelector(`${inputWrapperSelector} label`);
    this.input = document.querySelector(`${inputWrapperSelector} input`);
    this.button = document.querySelector(`${inputWrapperSelector} button`);
    this.inputValue = "";

    this.isFocused = false;
    this.isButtonFocused = false;
    this.isHovered = false;

    this.initialize();
  }

  initialize() {
    if (
      !this.checkboxWrapper ||
      !this.inputWraper ||
      !this.label ||
      !this.input ||
      !this.button
    ) {
      return;
    }

    this.inputWraper.addEventListener(
      "mouseenter",
      this.onMouseEnter.bind(this)
    );
    this.inputWraper.addEventListener(
      "mousemove",
      this.onMouseEnter.bind(this)
    );
    this.inputWraper.addEventListener(
      "mouseleave",
      this.onMouseLeave.bind(this)
    );

    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.input.addEventListener("blur", this.onBlur.bind(this));
    this.input.addEventListener("change", this.onChange.bind(this));

    this.button.addEventListener("focus", this.onButtonFocus.bind(this));
    this.button.addEventListener("blur", this.onButtonBlur.bind(this));
  }

  checkInputVisibility() {
    if (
      this.isFocused ||
      this.isButtonFocused ||
      this.isHovered ||
      !!this.inputValue
    ) {
      this.showInput();
    } else {
      this.hideInput();
    }
  }

  showInput() {
    this.label.classList.add("visible");
    this.checkboxWrapper.classList.add("visible");
  }

  hideInput() {
    this.label.classList.remove("visible");
    this.checkboxWrapper.classList.remove("visible");
  }

  onMouseEnter() {
    this.isHovered = true;
    this.checkInputVisibility();
  }

  onMouseLeave() {
    this.isHovered = false;
    this.checkInputVisibility();
  }

  onFocus() {
    this.isFocused = true;
    this.checkInputVisibility();
  }

  onBlur() {
    this.isFocused = false;
    this.checkInputVisibility();
  }

  onButtonFocus() {
    this.isButtonFocused = true;
    this.checkInputVisibility();
  }

  onButtonBlur() {
    this.isButtonFocused = false;
    this.checkInputVisibility();
  }

  onChange(event) {
    this.inputValue = event.target.value;
    this.checkInputVisibility();
  }
}

class Features {
  constructor({ featuresWrapperSelector }) {
    this.wrapper = document.querySelector(featuresWrapperSelector);
    this.features = document.querySelectorAll(
      `${featuresWrapperSelector} .feature`
    );

    this.initialize();
  }

  initialize() {
    if (!window.IntersectionObserver || !this.wrapper || !this.features) {
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.showFeatures();
            this.observer.unobserve(this.wrapper);
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.2,
      }
    );
    this.observer.observe(this.wrapper);
  }

  showFeatures() {
    this.features.forEach((element, index) => {
      setTimeout(() => element.classList.add("visible"), index * 450);
    });
  }
}

document.querySelector(".burger").addEventListener("click", menuVisibility);

window.addEventListener("DOMContentLoaded", function () {
  let desktop = null;
  let tablet = null;

  function slidesCounting() {
    const slides = document.querySelectorAll(".slide").length;
    if (slides >= 3) {
      desktop = 3;
      tablet = desktop - 1;
    } else {
      desktop = slides;
      tablet = slides;
    }
  }
  slidesCounting();

  new Swiper(".swiper-container-awards", {
    preloadImages: false,
    lazy: true,
    navigation: {
      nextEl: ".slider-awards-arrow--next",
      prevEl: ".slider-awards-arrow--prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      960: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    watchSlidesProgress: true,
    centerInsufficientSlides: true,
  });

//Banner Slider for Press and Media page
new Swiper(".swiper-container-awards.press-and-news-slider", {
  preloadImages: false,
  lazy: true,
  navigation: {
    nextEl: ".slider-awards-arrow--next",
    prevEl: ".slider-awards-arrow--prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    960: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 30,
    },
  },
  watchSlidesProgress: true,
  centerInsufficientSlides: false,
});
var swiper = new Swiper(".oasis-thumbnail-Swiper", {
  //loop: true,
  freeMode: false,
  breakpoints: {
    320: {
      slidesPerView: 1.5,
      spaceBetween: 24,
    },
    600: {
      slidesPerView: 3.5,
      spaceBetween: 24,
    },
    960: {
      slidesPerView: 4.5,
      spaceBetween: 24,
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 24,
    }
  },
  watchSlidesProgress: true,
});
var swiper2 = new Swiper(".oasis-active-slide-content", {
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});

  const input = document.getElementById("return-input");
  input.value = window.location.href + "#footer-form";

  new NewsletterForm({
    inputWrapperSelector: "#hero-form .newsletter__input-wrapper",
    checkboxWrapperSelector: "#hero-form .newsletter__checkbox-wrapper",
  });
  new NewsletterForm({
    inputWrapperSelector: "#newsletter-footer .newsletter__input-wrapper",
    checkboxWrapperSelector: "#newsletter-footer .newsletter__checkbox-wrapper",
  });

  new Features({ featuresWrapperSelector: ".features-wrapper" });
});

function showMorePagination({ moreBtn, items, columnsByScreen, rows = 3 }) {
  const isM = window.matchMedia("(min-width: 601px)").matches;
  const isXl = window.matchMedia("(min-width: 1024px)").matches;

  const columns = isXl
    ? columnsByScreen.XL
    : isM
    ? columnsByScreen.M
    : columnsByScreen.S;
  const increment = rows * columns;

  var visiblePressCount = 0;
  function showMoreItems() {
    const start = visiblePressCount;
    visiblePressCount = Math.min(start + increment, items.length);

    for (let i = start; i < visiblePressCount; i++) {
      items[i].style.display = "block";
    }

    const allVisible = items.length === visiblePressCount;
    moreBtn.style.opacity = allVisible ? 0 : 1;
  }

  moreBtn.addEventListener("click", (ev) => {
    showMoreItems();
    ev.target.blur();
  });

  showMoreItems();
}

const moreBtn = document.querySelector(".show-more-btn");

if (moreBtn) {
  showMorePagination({
    items: document.querySelectorAll(".paginated-card"),
    moreBtn,
    columnsByScreen: {
      S: 1,
      M: 2,
      XL: 3,
    },
  });
}

//Code for Press and Media Load more
var mediaCount = 0;
var pressCount = 0;
//This one is for Press/News
function showMorePaginationPress({ moreBtn, items, columnsByScreen, rows = 10 }) {
  const isM = window.matchMedia("(min-width: 601px)").matches;
  const isXl = window.matchMedia("(min-width: 1024px)").matches;
  const columns = isXl
    ? columnsByScreen.XL
    : isM
    ? columnsByScreen.M
    : columnsByScreen.S;
  const increment = rows * columns;

  var visiblePressCount = 0;
  function showMoreItemsPress() {
    const start = visiblePressCount;
    visiblePressCount = Math.min(start + increment, items.length);

    for (let i = start; i < visiblePressCount; i++) {
      items[i].style.display = "block";
    }

    const allVisible = items.length === visiblePressCount;
    moreBtnPress.style.opacity = allVisible ? 0 : 1;
    mediaCount = allVisible ? 0 : 1;
  }

  moreBtnPress.addEventListener("click", (ev) => {
    showMoreItemsPress();
    ev.target.blur();
  });

  showMoreItemsPress();

}


//Initialize on page load for Load More Press/NEWS Button
const moreBtnPress = document.querySelector(".show-more-news");

if (moreBtnPress) {
  showMorePaginationPress({
    items: document.querySelectorAll(".news-container .paginated-card"),
    moreBtnPress,
    columnsByScreen: {
      S: 1,
      M: 1,
      XL: 1,
    },
  });
}


//This one is for Media
function showMorePaginationMedia({ moreBtn, items, columnsByScreen, rows = 6 }) {
  const isM = window.matchMedia("(min-width: 601px)").matches;
  const isXl = window.matchMedia("(min-width: 1024px)").matches;
  const columns = isXl
    ? columnsByScreen.XL
    : isM
    ? columnsByScreen.M
    : columnsByScreen.S;
  const increment = rows * columns;
  var visiblePressCount = 0;
  function showMoreItemsMedia() {
    const start = visiblePressCount;
    visiblePressCount = Math.min(start + increment, items.length);

    for (let i = start; i < visiblePressCount; i++) {
      items[i].style.display = "block";
    }

    const allVisible = items.length === visiblePressCount;
    moreBtnMedia.style.opacity = allVisible ? 0 : 1;
    pressCount = allVisible ? 0 : 1;
  }

  moreBtnMedia.addEventListener("click", (ev) => {
    showMoreItemsMedia();
    ev.target.blur();
  });

  showMoreItemsMedia();

}


//Initialize on page load for Load More Media Button
const moreBtnMedia = document.querySelector(".show-more-media");

if (moreBtnMedia) {
  showMorePaginationMedia({
    items: document.querySelectorAll(".media-container .paginated-card"),
    moreBtnMedia,
    columnsByScreen: {
      S: 1,
      M: 1,
      XL: 1,
    },
  });
}

//Initialize on page load for Load More Common Button for Media and Press
const moreBtnMAP = document.querySelector(".show-more-press-and-news");

if (moreBtnMAP) {
  moreBtnMAP.addEventListener("click", (ev) => {
    document.querySelector(".show-more-media").click();
    document.querySelector(".show-more-news").click();
    if(mediaCount == 0  && pressCount == 0){
      moreBtnMAP.style.opacity = 0;
    }
  });
}


function lazyLoadImages() {
  var lazyImages = document.querySelectorAll("[data-src]");

  let lazyImageObserver = new IntersectionObserver(function (
    entries,
    observer
  ) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        let lazyImage = entry.target;
        lazyImage.src = lazyImage.dataset.src;
        lazyImageObserver.unobserve(lazyImage);
      }
    });
  });

  lazyImages.forEach(function (lazyImage) {
    lazyImageObserver.observe(lazyImage);
  });
}

lazyLoadImages();
